{
  "name": "daedalus-v2",
  "private": true,
  "version": "1.30.11",
  "type": "module",
  "scripts": {
    "dev": "vite --host --port 3001",
    "dev:mock": "cross-env VITE_USE_MOCK_DATA=true pnpm dev",
    "dev:demo": "cross-env VITE_DEMO=true pnpm dev",
    "dev:capture": "cross-env VITE_CAPTURE=true pnpm dev",
    "build": "tsc && vite build",
    "build:e2e": "vite build",
    "build:cicd": "env-cmd -f .env.cicd pnpm run build",
    "build:demo": "env-cmd -f .env.demo pnpm run build",
    "build:demo:deploy": "env-cmd -f .env.demo.deploy pnpm run build",
    "check": "concurrently -r \"pnpm check:types\" \"pnpm check:lint\" \"pnpm check:cycles\" \"pnpm --filter @bylt/e2e check\"",
    "check:types": "tsc --noEmit",
    "check:lint": "eslint ./src",
    "check:cycles": "madge --circular --extensions ts,tsx --ts-config tsconfig.json src",
    "check:bundle": "node scripts/scan-bundle.js",
    "check:bundle:secrets": "node scripts/scan-bundle.js --secrets",
    "check:dead": "knip --production",
    "check:dead:all": "knip",
    "check:dup": "jscpd --threshold 3",
    "format": "prettier --write ./src --config .prettierrc",
    "format:single": "prettier --write --config .prettierrc",
    "terraform:build": "env-cmd -f .env.terraform pnpm run build",
    "terraform:format": "terraform fmt ./terraform",
    "analyze": "cross-env VITE_ANALYZE=true pnpm run build",
    "test": "vitest",
    "test:ci": "vitest run --reporter=github-actions --reporter=dot",
    "test:ui": "vitest --ui",
    "test:e2e": "pnpm --filter @bylt/e2e test",
    "test:demo": "pnpm --filter @bylt/e2e test:demo",
    "codegen:bql": "node scripts/codegen-bql.js",
    "bump": "node scripts/bump.js",
    "deploy": "node scripts/deploy.js",
    "prepare": "husky"
  },
  "dependencies": {
    "@ai-sdk/react": "^3.0.210",
    "@base-ui/react": "^1.7.0",
    "@clerk/react": "^6.12.10",
    "@date-fns/tz": "^1.5.0",
    "@daypicker/react": "10.0.1",
    "@dnd-kit/collision": "^0.5.0",
    "@dnd-kit/dom": "^0.5.0",
    "@dnd-kit/helpers": "^0.5.0",
    "@dnd-kit/react": "^0.5.0",
    "@fontsource-variable/jetbrains-mono": "^5.3.0",
    "@fontsource/poppins": "^5.3.0",
    "@maskito/core": "^5.3.1",
    "@maskito/kit": "^5.3.1",
    "@maskito/react": "^5.3.1",
    "@posthog/react": "^1.10.3",
    "@radix-ui/react-use-controllable-state": "^1.2.6",
    "@react-pdf/renderer": "^4.5.1",
    "@sentry/react": "^10.69.0",
    "@streamdown/cjk": "^1.0.3",
    "@streamdown/math": "^1.0.2",
    "@t3-oss/env-core": "^0.13.11",
    "@tanstack/query-async-storage-persister": "^5.101.4",
    "@tanstack/react-form": "^1.33.3",
    "@tanstack/react-query": "^5.101.4",
    "@tanstack/react-query-devtools": "^5.101.4",
    "@tanstack/react-query-persist-client": "^5.101.4",
    "@tanstack/react-router": "^1.170.18",
    "@tanstack/react-router-devtools": "^1.167.0",
    "@tanstack/react-table": "^8.21.3",
    "@tanstack/react-virtual": "^3.14.9",
    "@tanstack/zod-adapter": "^1.167.0",
    "@uidotdev/usehooks": "^2.4.1",
    "ai": "^6.0.208",
    "canvas-confetti": "^1.9.4",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "cmdk": "^1.1.1",
    "date-fns": "^4.4.0",
    "dompurify": "^3.4.13",
    "embla-carousel-react": "^8.6.0",
    "input-otp": "^1.4.2",
    "lucide-react": "^1.28.0",
    "motion": "^12.43.0",
    "posthog-js": "^1.411.0",
    "qrcode.react": "^4.2.0",
    "react": "19.2.8",
    "react-dom": "19.2.8",
    "react-dropzone": "^20.0.0",
    "react-fast-compare": "^3.2.2",
    "react-grid-layout": "^2.2.4",
    "react-joyride": "^3.2.0",
    "react-markdown": "^10.1.0",
    "react-querybuilder": "^8.22.0",
    "react-resizable-panels": "^4.12.2",
    "react-top-loading-bar": "^3.0.2",
    "recharts": "3.10.1",
    "shadcn": "^4.16.1",
    "sonner": "^2.0.7",
    "streamdown": "^2.5.0",
    "tailwind-merge": "^3.6.0",
    "tinyduration": "^3.4.1",
    "tw-animate-css": "^1.4.0",
    "use-stick-to-bottom": "^1.1.6",
    "vaul": "^1.1.2",
    "zod": "^4.4.3",
    "zustand": "^5.0.14"
  },
  "devDependencies": {
    "@babel/core": "^8.0.1",
    "@clerk/shared": "^4.25.10",
    "@eslint-react/eslint-plugin": "^5.18.2",
    "@eslint/js": "^10.0.1",
    "@faker-js/faker": "^10.5.0",
    "@ianvs/prettier-plugin-sort-imports": "^4.7.1",
    "@playwright/test": "^1.62.1",
    "@rolldown/plugin-babel": "^0.2.3",
    "@sentry/vite-plugin": "^5.4.0",
    "@svgr/plugin-jsx": "^8.1.0",
    "@svgr/plugin-svgo": "^8.1.0",
    "@tailwindcss/typography": "^0.5.20",
    "@tailwindcss/vite": "^4.3.3",
    "@tanstack/eslint-plugin-query": "^5.101.4",
    "@tanstack/eslint-plugin-router": "^1.162.0",
    "@tanstack/router-plugin": "^1.168.23",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^7.0.0",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.6.3",
    "@types/babel__core": "^7.20.5",
    "@types/canvas-confetti": "^1.9.0",
    "@types/node": "^26.1.2",
    "@types/react": "^19.2.18",
    "@types/react-dom": "^19.2.4",
    "@vitejs/plugin-react": "^6.0.5",
    "@vitest/browser": "^4.1.10",
    "@vitest/coverage-istanbul": "^4.1.10",
    "@vitest/coverage-v8": "^4.1.10",
    "@vitest/ui": "^4.1.10",
    "babel-plugin-react-compiler": "19.1.0-rc.3",
    "browserslist": "^4.28.7",
    "concurrently": "^10.0.4",
    "cross-env": "catalog:",
    "env-cmd": "^11.0.0",
    "eslint": "^10.8.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.5",
    "eslint-plugin-boundaries": "^7.1.0",
    "eslint-plugin-react-hooks": "7.1.1",
    "husky": "^9.1.7",
    "jscpd": "^5.0.14",
    "jsdom": "^30.0.1",
    "knip": "^6.31.0",
    "lightningcss": "^1.33.0",
    "madge": "^8.0.0",
    "msw": "^2.15.0",
    "playwright": "^1.62.1",
    "prettier": "^3.9.6",
    "prettier-plugin-tailwindcss": "^0.8.1",
    "tailwindcss": "^4.3.3",
    "tsx": "^4.22.4",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.66.0",
    "vite": "^8.2.0",
    "vite-bundle-analyzer": "^1.3.9",
    "vite-plugin-svgr": "^5.2.0",
    "vitest": "^4.1.10"
  },
  "msw": {
    "workerDirectory": [
      "public"
    ]
  },
  "engines": {
    "node": ">=24.15",
    "pnpm": ">=11"
  },
  "packageManager": "pnpm@11.20.0"
}
